(function () {
  'use strict';

  if (window.__bnShilajitPdpInit) {
    window.__bnShilajitPdpInit();
    return;
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var narrow = window.matchMedia && window.matchMedia('(max-width: 749px)');

  /* A transparent film ships twice: VP9-with-alpha in WebM, and the same cut
     flattened onto the paper colour as h264. The band's background IS that paper
     colour, so the fallback is visually identical rather than a downgrade; it
     exists only for engines that cannot decode alpha WebM, which would otherwise
     paint the transparent region solid black. Sections that ship a single cut
     carry no -fallback attribute and are untouched by this. */
  function pickCodec(video, src, fallbackAttr) {
    var fallback = video.getAttribute(fallbackAttr);
    if (!fallback || !src) return src || fallback;
    if (/\.webm$/i.test(src) && !(video.canPlayType && video.canPlayType('video/webm; codecs="vp9"'))) return fallback;
    return src;
  }

  function selectSource(video) {
    var desktop = pickCodec(video, video.getAttribute('data-desktop-src'), 'data-desktop-fallback');
    var mobile = pickCodec(video, video.getAttribute('data-mobile-src'), 'data-mobile-fallback');
    var desktopPoster = video.getAttribute('data-desktop-poster');
    var mobilePoster = video.getAttribute('data-mobile-poster');
    if (!desktop && !mobile) return;
    var next = narrow && narrow.matches && mobile ? mobile : desktop || mobile;
    var nextPoster = narrow && narrow.matches && mobilePoster ? mobilePoster : desktopPoster || mobilePoster;
    if (nextPoster && video.getAttribute('poster') !== nextPoster) {
      video.setAttribute('poster', nextPoster);
      var mediaRoot = video.closest('.bn-shj-cine__film, .bn-shj-mountain__film');
      if (mediaRoot) mediaRoot.style.backgroundImage = 'url("' + nextPoster.replace(/"/g, '%22') + '")';
    }
    if (!next || video.getAttribute('src') === next) return;
    var wasPlaying = !video.paused;
    var inView = video.dataset.bnShilajitInView === '1';
    var allowPlayback = !(reduce && reduce.matches) && (wasPlaying || inView);
    if (allowPlayback) video.setAttribute('autoplay', '');
    else video.removeAttribute('autoplay');
    video.setAttribute('src', next);
    video.load();
    if (!allowPlayback) video.pause();
    if (allowPlayback) {
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
    }
  }

  function initResponsiveSources() {
    var videos = document.querySelectorAll('[data-bn-shilajit-video]');
    for (var i = 0; i < videos.length; i++) selectSource(videos[i]);
  }

  function initScrub(root) {
    if (root.dataset.bnShilajitScrubInit) return;
    root.dataset.bnShilajitScrubInit = '1';
    var video = root.querySelector('[data-bn-shilajit-scrub-video]');
    if (!video) return;
    selectSource(video);

    if (reduce && reduce.matches) {
      video.pause();
      return;
    }

    var ticking = false;
    /* Progress is measured against the FILM's own box and finishes when the film
       is CENTRED in the viewport, not when the whole section has gone past.

       Measuring the section was wrong on phones and it cost the payoff. The band
       stacks there, so the section is the film plus all of the copy beneath it,
       roughly 1500px against a 700px film. Half of that travel puts the film well
       above the fold, so the reader met the dissolve around its halfway frame and
       the gold water only arrived after the film had scrolled off the top. They
       never saw the thing the section exists to show.

       Anchoring to the film instead: 0 when its top edge is at the bottom of the
       viewport, 1 when its centre reaches the viewport centre. The bloom finishes
       by the time the film is the thing you are looking at, and it then HOLDS on
       the gold water for the rest of the scroll rather than racing to finish on
       the way out. The unit is the film's own height, so this holds at every
       breakpoint and for either cut. Only initScrub changes; initBeforeFilm below
       keeps the section-based window its own layout was tuned for. */
    var seek = function () {
      ticking = false;
      if (!Number.isFinite(video.duration) || video.duration <= 0) return;
      var rect = video.getBoundingClientRect();
      if (rect.height <= 0) return;
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var travel = (viewport + rect.height) / 2;
      var progress = travel > 0 ? (viewport - rect.top) / travel : 0;
      progress = Math.max(0, Math.min(1, progress));
      var nextTime = progress * Math.max(0, video.duration - 0.05);
      if (Math.abs(video.currentTime - nextTime) > 0.035) video.currentTime = nextTime;
    };
    var requestSeek = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(seek);
    };

    video.pause();
    video.addEventListener('loadedmetadata', requestSeek, { once: true });
    window.addEventListener('scroll', requestSeek, { passive: true });
    window.addEventListener('resize', requestSeek, { passive: true });
    requestSeek();
  }

  function initLoopVideo(video) {
    if (video.dataset.bnShilajitLoopInit) return;
    video.dataset.bnShilajitLoopInit = '1';
    selectSource(video);
    if (reduce && reduce.matches) {
      video.pause();
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var inView = entries[i].isIntersecting && !video.closest('[hidden]');
        video.dataset.bnShilajitInView = inView ? '1' : '0';
        if (inView) {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          video.pause();
        }
      }
    }, { threshold: 0.28 });
    observer.observe(video);
  }

  function initBeforeFilm(root) {
    if (root.dataset.bnShilajitBeforeInit) return;
    root.dataset.bnShilajitBeforeInit = '1';
    var video = root.querySelector('[data-bn-shilajit-before-video]');
    if (!video) return;
    selectSource(video);

    var observer = null;
    var ticking = false;
    var seek = function () {
      ticking = false;
      if (!Number.isFinite(video.duration) || video.duration <= 0) return;
      var rect = root.getBoundingClientRect();
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var progress = (viewport - rect.top) / (viewport + rect.height);
      progress = Math.max(0, Math.min(1, progress));
      var nextTime = progress * Math.max(0, video.duration - 0.05);
      if (Math.abs(video.currentTime - nextTime) > 0.035) video.currentTime = nextTime;
    };
    var requestSeek = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(seek);
    };
    var stopMode = function () {
      window.removeEventListener('scroll', requestSeek);
      window.removeEventListener('resize', requestSeek);
      if (observer) observer.disconnect();
      observer = null;
      video.pause();
    };
    var syncMode = function () {
      stopMode();
      video.removeAttribute('autoplay');
      video.loop = false;
      if (reduce && reduce.matches) return;

      if (narrow && narrow.matches) {
        video.loop = true;
        video.setAttribute('autoplay', '');
        if (!('IntersectionObserver' in window)) return;
        observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              var play = video.play();
              if (play && play.catch) play.catch(function () {});
            } else {
              video.pause();
            }
          }
        }, { threshold: 0.32 });
        observer.observe(video);
        return;
      }

      window.addEventListener('scroll', requestSeek, { passive: true });
      window.addEventListener('resize', requestSeek, { passive: true });
      video.addEventListener('loadedmetadata', requestSeek, { once: true });
      requestSeek();
    };

    syncMode();
    if (narrow && narrow.addEventListener) narrow.addEventListener('change', syncMode);
  }

  function initTabs(root) {
    if (root.dataset.bnShilajitTabsInit) return;
    root.dataset.bnShilajitTabsInit = '1';
    var radios = root.querySelectorAll('input[type="radio"]');
    var panels = root.querySelectorAll('[data-bn-shilajit-panel]');
    var labels = root.querySelectorAll('[data-bn-shilajit-tab]');
    var sync = function (reveal) {
      for (var i = 0; i < radios.length; i++) {
        var selected = radios[i].checked;
        if (selected) {
          root.dataset.activeIndex = String(i + 1);
          root.style.setProperty('--bn-shj-active-index', String(i));
        }
        if (selected && reveal && narrow && narrow.matches && labels[i] && labels[i].scrollIntoView) {
          labels[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce && reduce.matches ? 'auto' : 'smooth' });
        }
        if (panels[i]) {
          panels[i].setAttribute('aria-hidden', selected ? 'false' : 'true');
          var videos = panels[i].querySelectorAll('[data-bn-shilajit-loop]');
          for (var j = 0; j < videos.length; j++) {
            if (!selected || (reduce && reduce.matches)) videos[j].pause();
            else {
              var play = videos[j].play();
              if (play && play.catch) play.catch(function () {});
            }
          }
        }
      }
    };
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', function () { sync(true); });
    sync(false);
  }

  function init() {
    initResponsiveSources();
    var scrubs = document.querySelectorAll('[data-bn-shilajit-scrub]');
    for (var i = 0; i < scrubs.length; i++) initScrub(scrubs[i]);
    var beforeFilms = document.querySelectorAll('[data-bn-shilajit-before]');
    for (var b = 0; b < beforeFilms.length; b++) initBeforeFilm(beforeFilms[b]);
    var loops = document.querySelectorAll('[data-bn-shilajit-loop]');
    for (var j = 0; j < loops.length; j++) initLoopVideo(loops[j]);
    var tabs = document.querySelectorAll('[data-bn-shilajit-tabs]');
    for (var k = 0; k < tabs.length; k++) initTabs(tabs[k]);
  }

  window.__bnShilajitPdpInit = init;
  if (narrow && narrow.addEventListener) narrow.addEventListener('change', initResponsiveSources);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
